import { gql } from "@apollo/client";
import {ExceptionDictionaryType} from "./getAllException";

export const GET_EXCEPTION_DICTIONARY_BY_REASON_CODE = gql`
    query ExceptionDictionaryQuery($exceptionReasonCode: String!) {
        getExceptionDictionaryByReasonCode(exceptionReasonCode: $exceptionReasonCode) {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
        }
    }
`;

export interface ExceptionDictionaryByCodeResponse {
    getExceptionDictionaryByReasonCode: ExceptionDictionaryType;
}